import { PublicationCode } from '@/scopes/common/domain/types'

export const TEMPLATE_NAMES = {
  PDP: 'AccommodationPage',
}

export const BRAND = {
  SUNWEB: 'sunweb',
  ELIZA: 'eliza',
}

export const PUBLICATION_CODE: Record<string, PublicationCode> = {
  SUNWEB_NL_SUMMER: 'SZ',
  SUNWEB_FR_SUMMER: 'FZ',
  SUNWEB_DK_SUMMER: 'KZ',
  SUNWEB_SE_SUMMER: 'QZ',
  SUNWEB_BE_NL_SUMMER: 'BZ',
  SUNWEB_BE_FR_SUMMER: 'FS',
  SUNWEB_NL_WINTER: 'WG',
  SUNWEB_DE_WINTER: 'DW',
  SUNWEB_FR_WINTER: 'FW',
  SUNWEB_DK_WINTER: 'KW',
  SUNWEB_UK_WINTER: 'UW',
  SUNWEB_SE_WINTER: 'QW',
  SUNWEB_BE_NL_WINTER: 'BW',
  SUNWEB_BE_FR_WINTER: 'FH',
  ELIZA_NL: 'EZ',
  ELIZA_BE: 'BE',
  ELIZA_UK: 'UE',
  GOGO_NL: 'JR',
}

export const SUNWEB_PUBLICATION_CODES = {
  summer: [
    PUBLICATION_CODE.SUNWEB_NL_SUMMER,
    PUBLICATION_CODE.SUNWEB_FR_SUMMER,
    PUBLICATION_CODE.SUNWEB_DK_SUMMER,
    PUBLICATION_CODE.SUNWEB_SE_SUMMER,
    PUBLICATION_CODE.SUNWEB_BE_NL_SUMMER,
    PUBLICATION_CODE.SUNWEB_BE_FR_SUMMER,
  ],
  winter: [
    PUBLICATION_CODE.SUNWEB_NL_WINTER,
    PUBLICATION_CODE.SUNWEB_DE_WINTER,
    PUBLICATION_CODE.SUNWEB_FR_WINTER,
    PUBLICATION_CODE.SUNWEB_DK_WINTER,
    PUBLICATION_CODE.SUNWEB_UK_WINTER,
    PUBLICATION_CODE.SUNWEB_SE_WINTER,
    PUBLICATION_CODE.SUNWEB_BE_NL_WINTER,
    PUBLICATION_CODE.SUNWEB_BE_FR_WINTER,
  ],
}

export const ELIZA_PUBLICATION_CODES = [
  PUBLICATION_CODE.ELIZA_NL,
  PUBLICATION_CODE.ELIZA_BE,
  PUBLICATION_CODE.ELIZA_UK,
]

export const SUMMER_PATHS = [
  '/vakantie/',
  '/nl/vakantie/',
  '/fr/vacances/',
  '/solresor/',
  '/rejser/',
  '/vacances/',
] as const
